module.exports = __webpack_public_path__ + "img/nest.77a4880c.png";